module.exports = __webpack_public_path__ + "static/img/lb3.384ddd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/trace/lb3.png
// module id = 1704
// module chunks = 2